import React from 'react';
import styled from 'styled-components';
import { ReportFormatNumber } from '../../../../func/Function';

interface Props {
  list: any[];
  onClose: () => void;
}

function ExpectedModal({ list, onClose }: Props) {
  const cleanText = (input: any) => {
    // 입력값에 HTML 태그가 포함되어 있는지 확인
    if (!/<[^>]+>/g.test(input)) {
      return input; // 태그가 없으면 그대로 반환
    }

    // HTML 태그를 제거하고 <br> 태그를 공백으로 변경
    return input
      .replace(/<br\s*\/?>/g, ' ') // <br> 태그를 공백으로 변경
      .replace(/<[^>]+>/g, ''); // 모든 HTML 태그 제거
  };

  return (
    <Container>
      <Header>
        <Icon onClick={onClose}>
          <img src="/assets/images/close/close_black-big.svg" alt="" />
        </Icon>
        <HeaderTitle>예상 배당표</HeaderTitle>
        <Icon />
      </Header>
      <Content>
        <table style={{ borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <TableHeadTh width={'22%'}>순위/ 권리</TableHeadTh>
              <TableHeadTh width={'26%'}>채권자/ 채권액</TableHeadTh>
              <TableHeadTh width={'26%'}>배당액/{<br />}배당비율</TableHeadTh>
              <TableHeadTh width={'26%'}>
                매수인 인수금액/ 소멸 여부
              </TableHeadTh>
            </tr>
          </thead>
          <tbody>
            {list.length > 1 &&
              list.map((item, index) => (
                <tr key={index}>
                  <TablebodyTd width={'22%'}>
                    {item.idx}/{item.rank}
                  </TablebodyTd>
                  <TablebodyTd width={'26%'}>
                    {item.creditor}/<br></br>
                    {ReportFormatNumber(item.max_bond_amt.replaceAll(',', ''))}
                  </TablebodyTd>
                  <TablebodyTd
                    width={'26%'}
                    // style={{ backgroundColor: '#E6F3FF' }}
                  >
                    {!item.div_amt && !item.div_rate
                      ? '-'
                      : `${ReportFormatNumber(item.div_amt)}
                           ${item.div_rate ? `/ ${item.div_rate}%` : '-'}`}
                  </TablebodyTd>
                  <TablebodyTd
                    width={'26%'}
                    style={{
                      backgroundColor: '#FBEBEC',
                      color: item.is_extinc === '소멸' ? '#F34545' : '#171e26',
                    }}
                  >
                    {ReportFormatNumber(item.acqu_amt)}/
                    {cleanText(item.is_extinc)}
                  </TablebodyTd>
                </tr>
              ))}
          </tbody>
        </table>
        <BackButtonContainer>
          <Divider />
          <BackButton onClick={onClose}>상세페이지로 돌아가기 {'>'}</BackButton>
          <Divider />
        </BackButtonContainer>
      </Content>
    </Container>
  );
}

export default ExpectedModal;

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  gap: 24px;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-bottom-width: 1px;
  padding: 6px;
`;

const Icon = styled.div`
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const HeaderTitle = styled.div`
  font-weight: 700;
  font-size: 16px;
`;

const Content = styled.div`
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const BackButtonContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #f7f7f9;
`;

const BackButton = styled.button`
  border-radius: 9999px;
  padding: 8px 20px;
  background: #f7f7f9;
  border: none;
  white-space: nowrap;

  font-weight: 500;
  font-size: 12px;
  color: #4e5968;
`;

const TableHeadTh = styled.th<{ width: string }>`
  width: ${({ width }) => width};
  text-align: center;
  border: 1px solid #e8e9ea;
  padding: 10px 4px;
  background: #f7f8fc;
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 26.1px */
  letter-spacing: -0.36px;
  color: #616161;
`;
const TablebodyTd = styled.td<{ width: string }>`
  width: ${({ width }) => width};
  text-align: center;
  border: 1px solid #e8e9ea;
  padding: 6px 8px;
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.32px;
  color: #171e26;
  word-wrap: break-word;
`;
